import { useMutation, useQueryClient } from "react-query";

import { favouriteItemsKey } from "../../queries";
import { deleteFavourite } from "./deleteFavourite.fetcher";
import { DeleteFavouriteMutationResult } from "./deleteFavourite.types";

export function useDeleteFavouriteMutation(): DeleteFavouriteMutationResult {
  const queryClient = useQueryClient();

  return useMutation(deleteFavourite, {
    onSettled: () => {
      queryClient.invalidateQueries(favouriteItemsKey);
    },
  });
}
